import { isEmpty } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { transformPaginatedEvents } from '../utils/PhotoCardUtils';
import type {
  PageType,
  PaginatedEvents,
  SelectedCollectedData
} from '../../../types/PhotoCardType';
import type { InfiniteData } from 'react-query';

interface UseProcessedPhotoCardEventsProps {
  data: InfiniteData<PageType>;
  updatedCollectedData: SelectedCollectedData;
  selectedCollectedData: SelectedCollectedData;
}

export const useProcessedPhotoCardEvents = ({
  data,
  updatedCollectedData,
  selectedCollectedData
}: UseProcessedPhotoCardEventsProps) => {
  const [paginatedEvents, setPaginatedEvents] = useState<PaginatedEvents>();

  const handlePaginatedData = useCallback(
    (newPaginatedData: InfiniteData<PageType>['pages']) => {
      const updatedEvents = transformPaginatedEvents({
        newPaginatedData,
        updatedCollectedData,
        selectedCollectedData
      });
      setPaginatedEvents(updatedEvents);
    },
    [selectedCollectedData, updatedCollectedData]
  );

  useEffect(() => {
    if (!isEmpty(data)) {
      handlePaginatedData(data.pages);
    }
  }, [data, handlePaginatedData]);

  return { paginatedEvents };
};
